// eslint-disable-next-line no-unused-vars
import React from "react";
import { string, array, element } from "prop-types";
import { get } from "lodash";
import { connect } from "react-redux";

import { checkRender } from "../../utils/utils";

import { PAGE_TYPES_NOT_ADS } from "../../../constants";

const DfpContainer = ({ children, pageType, pages = [], domains = [], domainSlug }) => {
  if (checkRender([...pages, ...PAGE_TYPES_NOT_ADS], pageType, [...domains, "trust"], domainSlug)) {
    return null;
  }

  return children;
};

DfpContainer.propTypes = {
  pageType: string,
  children: element,
  pages: array,
  domainSlug: string,
  domains: array,
};

const mapStateToProps = (state) => ({
  domainSlug: get(state, ["qt", "config", "domainSlug"]),
  pageType: get(state, ["qt", "pageType"]),
});

export default connect(mapStateToProps)(DfpContainer);
